<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item">
      <a href="javascript:void(0);" translate>Products</a>
    </li>
    <li class="breadcrumb-item active" aria-current="page" translate>Products List</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=c6fjRd8AWhI" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<div [hidden]="loading" class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
  <div class="widget-content widget-content-area br-6">

    <!-- Bulk Actions Dropdown -->
    <div class="mb-3 d-flex">
      <div class="dropdown">
        <select #bulkActionOptions class="btn btn-primary dropdown-toggle" id="bulkActionsDropdown" (change)="toggleSelectProduct()">
          <option value="" translate>Bulk Actions</option>
          <option value="delete" translate>Delete Selected</option>
          <option value="offline" translate>Turn Off Selected</option>
          <option value="online" translate>Turn On Selected</option>
        </select>
<!--        <div class="dropdown-menu" aria-labelledby="bulkActionsDropdown">-->
<!--          <a class="dropdown-item" href="javascript:void(0);" (click)="deleteSelectedProducts()">Delete Selected</a>-->
<!--        </div>-->
      </div>
    </div>

    <div class="table-responsive mb-4 mt-4">
      <table id="multi-column-ordering" class="table table-hover" style="width:100%">
        <thead>
        <tr>
          <!-- Checkbox Column -->
          <th>
            <input type="checkbox" (change)="toggleSelectAll($event)" />
          </th>
          <th translate>ID</th>
          <th translate>Thumbnail</th>
          <th translate>Title</th>
          <th translate>Price</th>
          <th translate>Description</th>
          <th translate>Stock Qty</th>
          <th translate>Status</th>
          <th translate>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let product of products">
          <!-- Checkbox Column -->
          <td>
            <input type="checkbox" [(ngModel)]="product.selected" />
          </td>
          <td>
            <del class="text-danger font-weight-bolder" *ngIf="product.stockQty <= 0">{{ product.id }}</del>
            <span *ngIf="product.stockQty > 0">{{ product.id }}</span>
          </td>
          <td>
            <div class="d-flex">
              <div class="usr-img-frame">
                <img alt="product image" class="img-fluid m-0 p-0" *ngIf="product.productImageId != null || product.thumbnailImageId != null" [src]="env.getRest() + '/openApi/downloadProductTinyThumbnailImageBytes/' + product.id">
                <img alt="Product image" class="img-fluid m-0 p-0" *ngIf="product.productImageId == null" src="/assets/img/no-image.png">
              </div>
            </div>
          </td>
          <td>
            <p *ngIf="product.stockQty > 0" class="align-self-center mb-0 admin-name">{{ product.title }}</p>
            <del *ngIf="product.stockQty <= 0" class="text-danger font-weight-bolder align-self-center mb-0 admin-name">{{ product.title }}</del>
          </td>
          <td nowrap="nowrap">
            <span *ngIf="product.stockQty > 0">{{ product.price }} <img height="18" src="assets/sr.svg" alt="SAR"></span>
            <del class="text-danger font-weight-bolder" *ngIf="product.stockQty <= 0">{{ product.price }} <img height="18" src="assets/sr.svg" alt="SAR"></del>
          </td>
          <td>
            <span *ngIf="product.stockQty > 0">{{ product.description }}</span>
            <del class="text-danger font-weight-bolder" *ngIf="product.stockQty <= 0">{{ product.description }}</del>
          </td>
          <td>
            <span *ngIf="product.stockQty > 0">{{ product.stockQty }}</span>
            <del class="text-danger font-weight-bolder" *ngIf="product.stockQty <= 0">{{ product.stockQty }}</del>
          </td>
          <td>
            <div [ngClass]="{'t-dot': true, ' bg-danger': !product.linkIdentity, 'bg-success' : product.linkIdentity}" data-toggle="tooltip" data-placement="top" [attr.data-original-title]="product.linkIdentity? onlineLabel : offlineLabel"></div>
          </td>
          <td class="text-center">
            <div class="dropdown">
              <a class="dropdown-toggle2" href="#" role="button" [id]="'dropdownMenuLink_' + product.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </a>
              <div class="dropdown-menu" [attr.aria-labelledby]="'dropdownMenuLink_' + product.id" style="will-change: transform;">
                <a class="dropdown-item" [routerLink]="['/private', 'product', 'edit', product.id]" [queryParams]="{type: subAccountType, govId: subAccountGovId}" href="javascript:void(0);" translate>Edit</a>
                <a *ngIf="isSales || isMerchant || isManager" class="dropdown-item" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#deleteModal' + product.id" translate>Delete</a>
                <a *ngIf="product.linkIdentity" class="dropdown-item" href="javascript:void(0);" (click)="shareProduct(product)" translate>Share Product Link</a>
                <a *ngIf="isSales || isMerchant || isManager" (click)="changeOnlineStatus(product.id, product.linkIdentity)" class="dropdown-item" href="javascript:void(0);" translate>{{ product.linkIdentity ? 'Offline' : 'Online' }}</a>
              </div>
            </div>

          </td>
          <!-- Modal -->
          <div class="modal fade" [id]="'deleteModal' + product.id" tabindex="-1" role="dialog" [attr.aria-labelledby]="'deleteModalLabel' + product.id" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" [id]="'deleteModalLabel' + product.id">{{ 'Delete Product' | translate }}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
                </div>
                <div class="modal-body">
                  <p class="modal-text">{{ 'Do you want to delete product of title' | translate }} "{{ product.title }}"</p>
                </div>
                <div class="modal-footer">
                  <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>No</button>
                  <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="deleteProduct(product.id, product.title)" translate>Yes</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th translate>ID</th>
          <th translate>Thumbnail</th>
          <th translate>Title</th>
          <th translate>Price</th>
          <th translate>Description</th>
          <th translate>Stock Qty</th>
          <th translate>Status</th>
          <th translate>Actions</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<app-share-panel [link]="productShareLink" modalId="productShareLink"></app-share-panel>
